<fb-data-autocomplete-templates></fb-data-autocomplete-templates>
<fb-notify></fb-notify>
<router-outlet></router-outlet>
